/** JSON-LD for /pickup — kept out of the page module for code splitting. */
export const BREADCRUMB_LD = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: "https://lohalink.in/" },
    { "@type": "ListItem", position: 2, name: "Scrap Pickup", item: "https://lohalink.in/pickup" },
  ],
};

export const SERVICE_LD = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Doorstep Scrap Pickup",
  serviceType: "Scrap metal collection and pickup",
  provider: {
    "@type": "Organization",
    name: "LohaLink",
    url: "https://lohalink.in",
    email: "lohalink.in@gmail.com",
    telephone: "+91-79801-56276",
  },
  areaServed: { "@type": "Country", name: "India" },
  description:
    "Free doorstep pickup for iron, steel and metal scrap from homes, shops, factories and yards in India. Transparent weighing, live benchmark rates and fast payment.",
  offers: {
    "@type": "Offer",
    priceCurrency: "INR",
    description: "Rate quoted against LohaLink live benchmark rates; pickup is free.",
  },
};

export const FAQ_LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Is LohaLink scrap pickup free?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Pickup and transport are free for qualifying quantities. You are paid for the weighed quantity of scrap at the agreed rate with no deduction for the vehicle.",
      },
    },
    {
      "@type": "Question",
      name: "What is the minimum quantity for a scrap pickup?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "For households and shops we usually collect from 50 kg upwards. For yards, factories and industrial lots there is no upper limit — bulk loads are handled as full-truck lots.",
      },
    },
    {
      "@type": "Question",
      name: "How is the scrap weighed and priced?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Material is weighed in front of you on a calibrated scale, or at a certified weighbridge for truck loads, and you receive the slip. The rate is quoted against LohaLink's live market benchmark for that material and city.",
      },
    },
    {
      "@type": "Question",
      name: "How soon will I be paid after pickup?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Payment is released to your bank account or UPI against the final weighed quantity, usually the same day for retail pickups and per the agreed terms for bulk lots.",
      },
    },
    {
      "@type": "Question",
      name: "Which cities does LohaLink pick up scrap from?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We operate across major Indian industrial clusters including Kolkata, Durgapur, Asansol, Jamshedpur, Raipur, Rourkela, Mandi Gobindgarh, Ghaziabad, Ahmedabad, Pune, Chennai and Hyderabad, and arrange transport elsewhere on request.",
      },
    },
  ],
};
